import '@fortawesome/fontawesome-free/css/all.css';
import './product-unit-tab.scss';
import { useEffect, useState } from 'react';
import { Product, ProductTrackingType } from '../../../clients/quipli-service/product/product';
import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import { Location } from '../../../clients/quipli-service/location/location';
import { ProductUnitTable } from './product-unit-table/product-unit-table';
import { ProductStock } from './product-quantity/product-stock';
import { Spinner } from '../../../components/spinner/spinner';
import { Configuration } from '../../../clients/quipli-service/configuration/configuration';
import { Dictionary, keyBy } from 'lodash';

export const ProductUnitsTab = ({ productId }: { productId: number }) => {
  const { listLocations, getProduct, getMultipleConfigurations } = useAPI();
  const [locations, setLocations] = useState<Location[]>();
  const [product, setProduct] = useState<Product>();
  const [configurations, setConfigurations] = useState<Dictionary<Configuration>>({});
  const saleSerialTrackingEnabled = configurations['CONF_SALE_SERIAL_TRACKING']?.value === '1';

  function refresh() {
    Promise.all([
      listLocations(),
      getProduct(productId),
      getMultipleConfigurations([
        'CONF_WORK_ORDERS',
        'CONF_ENABLE_QR_CODE',
        'CONF_UNIT_TRACKING_VIA',
        'CONF_BOOM_AND_BUCKET_INTEGRATION',
        'CONF_SALE_SERIAL_TRACKING',
        'CONF_WEBSITE_NAME',
        'CONF_BOOM_AND_BUCKET_SELLER_CONTACT_FIRST_NAME',
        'CONF_BOOM_AND_BUCKET_SELLER_CONTACT_LAST_NAME',
        'CONF_BOOM_AND_BUCKET_SELLER_CONTACT_EMAIL',
        'CONF_BOOM_AND_BUCKET_SELLER_CONTACT_PHONE',
      ]),
    ]).then(([ls, p, c]) => {
      setLocations(ls);
      setProduct(p);
      setConfigurations(keyBy(c, 'variable'));
    });
  }
  useEffect(() => {
    refresh();
  }, []);

  return product && locations ? (
    <div className="pu-tab">
      <ProductStock
        product={product}
        locations={locations}
        refresh={refresh}
        saleSerialTrackingEnabled={saleSerialTrackingEnabled}
      />

      {(product.allowRent || saleSerialTrackingEnabled) && product.trackingType === ProductTrackingType.SerialUnits && (
        <ProductUnitTable
          theProduct={product}
          allLocations={locations}
          configs={configurations}
          refreshProduct={refresh}
          setTheProduct={setProduct}
        />
      )}
    </div>
  ) : (
    <Spinner />
  );
};
